/** 活体&协议弹窗：moduleID */
export const TP_LIVENESS_SIGN_AGREEMENTS_POP_MODULE = 'finance_loan_faceID_agreementPopUp_new';
